<section class="main">
    <div class="heading d-flex justify-content-between align-items-center">
        <h1>Roles</h1>
        <div>
            <button class="btn" (click)="addRole()">Add new role</button>
        </div>
    </div>
    <!-- <div class="searchInput">
        <input class="form-control" type="text" placeholder="Search roles">
    </div> -->

    <!-- roles -->


    <section class="mt-5 d-flex  align-items-center roleSection">
        <div *ngFor="let item of role_arr">
            <div  class="roleItem d-flex align-items-center">
                <p>{{item.name}}</p>
                <img (click)="editRole(item)" src="assets/images/edit1.png">
            </div>
        </div>
    </section>
</section>